
import Tab from './Tab';
import TabGroup from './TabGroup';

Tab.Group = TabGroup;

export default Tab;


// WEBPACK FOOTER //
// ./components/Tab/index.js